import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'software-board-settings-general-filter-settings.board-filter-details.header',
		defaultMessage: 'Filter details',
		description: 'Header of filter details in general board settings',
	},
});
